/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerProject_Projects.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Projects
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, June 15, 2019 - 01:06:32 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      06/15/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PROJECT_LIST_CONTAINER_LOADED,
    PROJECT_LIST_CONTAINER_UNLOADED,
    PROJECT_LIST_TABLE_LOADED,
    PROJECT_LIST_TABLE_UNLOADED,
    PROJECT_LIST_CHANGE_GROUP,

    PROJECT_SELECT_ROW,
    PROJECT_ADD,
    PROJECT_EDIT,
    PROJECT_DELETE,
    PROJECT_OPEN_WARNING,
    PROJECT_CLOSE_WARNING,
    PROJECT_DELETE_DISABLE,

    PROJECT_EDIT_CONTAINER_LOADED,
    PROJECT_EDIT_CONTAINER_UNLOADED,
    PROJECT_EDIT_FORM_LOADED,
    PROJECT_EDIT_FORM_UNLOADED,
    PROJECT_EDIT_DATA_LOAD,
    PROJECT_EDIT_CONTAINER_SUBMIT,
    PROJECT_EDIT_CONTAINER_CANCEL,

    PROJECT_UPDATE_VALUE
} from '../constants/actionTypeProject_Projects';

const defaultState = {
    refreshList: false,
    danger: false,
    projectid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PROJECT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                projects: action.payload[0] ? action.payload[0].records : null,
                companies: action.payload[1] ? action.payload[1].companies : null,
                itempath: action.payload[2] ? action.payload[2].records : []
            }
        case PROJECT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PROJECT_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                projects: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[1] ? action.payload[1].records : []
            }
        case PROJECT_SELECT_ROW:
            return {
                ...state,
                projectid: action.id
            }
        case PROJECT_ADD:
            return {
                ...state
            }
        case PROJECT_EDIT:
            return {
                ...state,
                projectid: action.id
            }
        case PROJECT_DELETE:
            return {
                ...state,
                projectid: null
            }
        case PROJECT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case PROJECT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PROJECT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PROJECT_EDIT_CONTAINER_LOADED:
        case PROJECT_EDIT_DATA_LOAD:
            const noUser = 'No User Selected';
            let managerDisplay = action.payload[0] ? (action.payload[0].managerid !== 0 ? (action.payload[0].manager_firstname + ' ' + action.payload[0].manager_lastname + ' [ ' + action.payload[0].manager_username + ' ]') : noUser) : noUser;

            return {
                ...state,
                projectid: action.payload[0] ? action.payload[0].projectid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                company: action.payload[0] ? action.payload[0].company : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                startid: action.payload[0] ? action.payload[0].startid : 0,
                startdate: action.payload[0] ? action.payload[0].startdate : '',
                endid: action.payload[0] ? action.payload[0].endid : 0,
                enddate: action.payload[0] ? action.payload[0].enddate : '',
                managerid: action.payload[0] ? action.payload[0].managerid : 0,
                managerid_display: managerDisplay,
                manager_firstname: action.payload[0] ? action.payload[0].manager_firstname : '',
                manager_lastname: action.payload[0] ? action.payload[0].manager_lastname : '',
                manager_username: action.payload[0] ? action.payload[0].manager_username : '',
                projectcode: action.payload[0] ? action.payload[0].projectcode : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PROJECT_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case PROJECT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PROJECT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PROJECT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PROJECT_LIST_CONTAINER_UNLOADED:
        case PROJECT_LIST_TABLE_UNLOADED:
        case PROJECT_EDIT_CONTAINER_UNLOADED:
        case PROJECT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerProject_Projects.js